import React, { useEffect, useState } from 'react';

import { Layout, Menu } from 'antd';
import { Switch, Route, Link, useLocation, Redirect } from 'react-router-dom';

import useTranslate from '@core/hooks/useTranslate';
import { ADMIN_BUSK_MENU } from '@root/core/constants/Busk/busk-menu';
import BuskSeller from '@root/modules/Busk/Busk-Seller/pages/BuskSeller';
import BuskAdminDashboard from '@root/modules/Busk/Dashboard/pages/BuskAdminDashboard';
import BuskSellerDetail from '@root/modules/Busk/Busk-Seller-Detail/pages/BuskSellerDetail';
import BuskWarehouse from '@root/modules/Busk/Busk-Warehouse/page/BuskWarehouse';
import BuskWarehouseDetail from '@root/modules/Busk/BuskWarehouseDetail/pages/BuskWarehouseDetail';
import BuskStock from '@root/modules/Busk/BuskStock/pages/BuskStock';
import BuskStockDetail from '@root/modules/Busk/BuskStockDetail/pages/BuskStockDetail';
import BuskStockWarehouse from '@root/modules/Busk/BuskStockDetail/pages/BuskStockWarehouse';
import Settlement from '@root/modules/Busk/Settlement/pages/Settlement';
import WarehouseSettlement from '@root/modules/Busk/Settlement/pages/WarehouseSettlement';
import TransactionDetail from '@root/modules/Busk/Settlement/pages/TransactionDetail';
import LogisticsCenterDetail from '@root/modules/Busk/Settlement/pages/LogisticsCenterDetail';
import BuskForwarding from '@root/modules/Busk/Forwarding/pages/BuskForwarding';
import ForwardingDetail from '@root/modules/Busk/Forwarding-Deatil/pages/ForwardingDetail';
import ForwardingContent from '@root/modules/Busk/Forwarding-Content/pages/ForwardingContent';
import ForwardingCreate from '@root/modules/Busk/Forwarding-Create/pages/ForwardingCreate';
import ApiImport from '@root/modules/Busk/ApiImport/apiImport';

const { Sider, Content } = Layout;

interface Props {
  path?: string;
}

const BuskSidebar = ({ path = '' }: Props) => {
  const [t] = useTranslate();
  const [collapsed, setCollapsed] = useState(false);
  const [selected, setSeclected] = useState('');
  const [a, setA] = useState([] as any);
  const activeItem = (event: any) => {
    setSeclected(event.key);
  };
  const location = useLocation();

  useEffect(() => {
    let a = location;
    const b = a.pathname.replace('/admin/', '').split('/');
    setA(b);
  }, [location]);
  const colorParent = (item: {
    name?: string;
    label?: string;
    url: string;
    children?: { id: number; name: string; url: string }[];
  }) => {
    let isBold =
      !a[1] && item.url === '/admin/busk'
        ? 'bold'
        : a[1] === item.url.replace('/admin/busk/', '')
        ? 'bold'
        : !!a[1] &&
          a[1]
            .replace('/admin/busk/', '')
            .split('-')
            .includes(item.url.replace('/admin/busk/', ''))
        ? 'bold'
        : '500';
    return isBold;
  };

  const colorHasChild = (item: {
    id: number;
    name?: string;
    label?: string;
    url?: string;
    children: { id: number; name: string; url: string }[];
  }) => {
    let isbold = false;
    item.children.forEach((child) => {
      let bold =
        !!a[1] && !a[2] && a[1] == child.url.replace('/admin/busk/', '')
          ? true
          : !!a[2] && a[2] == child.url.replace('/admin/busk/' + a[1] + '/', '')
          ? true
          : !!a[2] &&
            child.url.includes(a[1]) &&
            child.url.replace('/admin/busk/', '').split('/')[0].includes(a[1])
          ? true
          : false;
      if (bold) isbold = true;
    });
    return isbold ? 'bold' : '500';
  };

  const renderAdminOrStoreHeader = () => {
    return (
      <Layout className="navigation">
        <Sider collapsedWidth="48" width="230" className="side-bar__menu">
          <Menu
            mode="inline"
            style={{ height: '100%', borderRight: 0 }}
            selectedKeys={[path]}
            className="busk-sidebar"
          >
            {ADMIN_BUSK_MENU.map((item: any, index: number) =>
              item.children ? (
                <Menu.SubMenu
                  title={item.label}
                  key={index}
                  style={{ fontWeight: colorHasChild(item) }}
                >
                  {item.children.map((child: any, idx: number) => (
                    <Menu.Item key={idx + 10}>
                      <Link
                        to={child.url}
                        style={{
                          fontWeight:
                            !!a[1] &&
                            !a[2] &&
                            a[1] == child.url.replace('/admin/busk/', '')
                              ? 'bold'
                              : !!a[2] &&
                                (a[2] ==
                                  child.url.replace(
                                    '/admin/busk/' + a[1] + '/',
                                    ''
                                  ) ||
                                  (!isNaN(a[2]) &&
                                    child.url.replace(
                                      '/admin/busk/' + a[1],
                                      ''
                                    ) == ''))
                              ? 'bold'
                              : '500'
                        }}
                      >
                        {t(child.name)}
                      </Link>
                    </Menu.Item>
                  ))}
                </Menu.SubMenu>
              ) : (
                <Menu.Item key={item.url}>
                  <Link
                    to={item.url}
                    style={{
                      color: selected === `tmp_key-${index}` ? '#0077ff' : '',
                      fontWeight: colorParent(item)
                    }}
                  >
                    {t(item.name)}
                  </Link>
                </Menu.Item>
              )
            )}
          </Menu>
        </Sider>
        <Layout>
          <Content
            style={{
              minHeight: 280,
              minWidth: 1080,
              overflow: 'auto'
            }}
          >
            <Switch>
              {/* Dashboard */}
              <Route exact path="/admin/busk">
                <BuskAdminDashboard />
              </Route>
              {/* Seller Management */}
              <Route exact path="/admin/busk/sellers">
                <BuskSeller />
              </Route>
              <Route exact path="/admin/busk/sellers/:id">
                <BuskSellerDetail />
              </Route>
              {/* Warehouse Management */}
              <Route exact path="/admin/busk/logistic">
                <BuskWarehouse />
              </Route>
              <Route exact path="/admin/busk/logistic/:id">
                <BuskWarehouseDetail />
              </Route>
              {/* Stock Management */}
              <Route exact path="/admin/busk/stock">
                <BuskStock />
              </Route>
              <Route path="/admin/busk/stock/:id">
                <BuskStockWarehouse />
              </Route>
              <Route exact path="/admin/busk/forwarding/create">
                <ForwardingCreate />
              </Route>
              <Route exact path="/admin/busk/forwarding/:id">
                <ForwardingDetail />
              </Route>

              <Route exact path="/admin/busk/forwarding/:id/:postId">
                <ForwardingContent />
              </Route>
              <Route path="/admin/busk/stock-detail/:id/:warehouseid/:productId">
                <BuskStockDetail />
              </Route>
              <Route exact path="/admin/busk/settlement">
                <Settlement />
              </Route>
              <Route exact path="/admin/busk/forwarding">
                <BuskForwarding />
              </Route>
              <Route exact path="/admin/busk/settlement/:id">
                <TransactionDetail />
              </Route>
              <Route exact path="/admin/busk/warehouse-settlement">
                <WarehouseSettlement />
              </Route>
              <Route exact path="/admin/busk/warehouse-settlement/:id">
                <LogisticsCenterDetail />
              </Route>
              <Route exact path="/admin/busk/api-import">
                <ApiImport />
              </Route>

              <Route path="">
                <Redirect to="/admin/busk" />
              </Route>
            </Switch>
          </Content>
        </Layout>
      </Layout>
    );
  };

  return renderAdminOrStoreHeader();
};

export default React.memo(BuskSidebar);
